export class AdminRequest {
  oktaUserId: string;

  constructor(userId: string) {
    this.oktaUserId = userId;
  }
}
